
import { defineComponent } from 'vue';

export default defineComponent({
  emits: ['colorChanged'],
  props: {
    colors: {
      type: Array,
      required: true
    },
    selectedColor: {
      type: String,
      required: true
    }
  },
  computed: {
    currentColor(): string {
      return this.selectedColor;
    }
  },
  methods: {
    changeColor(color: string) {
      this.$emit('colorChanged', color.slice(1));
    }
  }
});
